import { Center } from "@mantine/core"
import { SimpleLayout } from ".."

import classes from "./CenterLayout.module.css"

export function CenterLayout({ children }) {
  return (
    <SimpleLayout>
      <Center mih="calc(100vh - 50px)" classNames={classes}>
        {children}
      </Center>
    </SimpleLayout>
  )
}
